import StudioModule from "@/modules/studio";

export const StudioPage = () => {
  return (
    <div>
      <StudioModule />
    </div>
  );
};
